import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule, DIALOG_DATA, DialogRef, IconModule } from '@hglobal/common';
import { CoinComponent } from '@pt/components';
import { Balance, Skin } from '@pt/models';
import { environment } from '@pt/environment';
import { ImageLoaderDirective } from '@pt/directives';

@Component({
  imports: [
    TranslateModule,
    ButtonModule,
    IconModule,
    ReactiveFormsModule,
    ImageLoaderDirective,
    CoinComponent,
  ],
  selector: 'pu-balance-skin-form',
  templateUrl: './balance-skin-form.component.html',
  styleUrls: ['./balance-skin-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BalanceSkinFormComponent {
  assetsHost = environment.assetsHost;
  selectedSkin = this.data.balance.skin;
  balance = this.data.balance;
  skins = this.data.skins;

  constructor(
    private _dialogRef: DialogRef,
    @Inject(DIALOG_DATA) public data: { skins: Skin[]; balance: Balance },
  ) {
  }

  selectSkin(skin: Skin) {
    this.selectedSkin = skin;
  }

  apply() {
    this._dialogRef.close({
      skinId: this.selectedSkin.id,
      balanceType: this.balance.balanceType,
    });
  }

  close(): void {
    this._dialogRef.close();
  }
}
